export const getCategoriesWithProducts = state => state.categoriesWithProducts

export const getProducts = state => state.products
export const getProductById = state => id => state.products.find(p => p.id === id)
export const isLoading = state => state.loading
export const getError = state => state.error
export const getOnlineProducts = state => state.products.filter(p => p.online === 1)
export const getCategories = state => state.categories
export const getPaymentMethods = state => state.paymentMethods
export const getCustomers = state => state.customers

// Multi-cart getters
export const getCarts = state => state.carts
export const getActiveCartIndex = state => state.activeCartIndex
export const getActiveCartItems = state => state.carts[state.activeCartIndex]?.items || []
export const getActiveCartClient = state => state.carts[state.activeCartIndex]?.selectedClient || null

export const getActiveCartSubtotal = state => {
    const items = state.carts[state.activeCartIndex]?.items || []
    return items.reduce((s, i) => {
        const raw = i.price * i.quantity
        return s + (i.discount ? Math.round(raw * (1 - i.discount / 100)) : raw)
    }, 0)
}

export const getActiveCartTotal = (state, getters) => getters.getActiveCartSubtotal

export const getActiveCartTotalItems = state => {
    const items = state.carts[state.activeCartIndex]?.items || []
    return items.reduce((s, i) => s + i.quantity, 0)
}

export const getCartItemCounts = state => {
    return state.carts.map(cart => cart.items.length)
}

// Backward compat
export const getCart = state => state.carts[state.activeCartIndex]?.items || []
